'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var DEFAULT_SIZE = 24;
exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
    fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
    _ref$width = _ref.width,
    width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
    _ref$style = _ref.style,
    style = _ref$style === undefined ? {} : _ref$style,
    props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
    style: _extends({
      fill: fill,
      width: width,
      height: height
    }, style)
  }, props), _react2.default.createElement('path', {
    d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
  }));
};